// import '../../styles/index.scss';
// bump

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/blur-up/ls.blur-up';

import '../components/quantity';
import '../sections/collection-list';
import '../sections/notification-bar';
import '../sections/site-header';
import '../snippets/store-locator-dd';

import { focusHash } from '@shopify/theme-a11y';
import { load } from '@shopify/theme-sections';
import Accordion from '../components/accordion';
import AjaxCart from '../components/ajax-cart';
import CartFunctions from '../helpers/cart-functions';
import EventBus from '../helpers/event-bus';
import LazyVideo from '../snippets/lazy';
import FreeGift from '../components/free-gift';
import FreeShipping from '../components/free-shipping';
import GiftWrap from '../components/giftwrapping';

import '../components/gift-card';
// TODO: loadPage Remove to increase speed
import Loadpage from '../components/loadpage';
import Location from '../snippets/store-locator-dd';
import ModalLocation from '../sections/modal-redirect';
import MeganavProduct from '../components/meganav-products';
import Navigation from '../components/navigation';
import QuickAdd from '../components/quick-add';
import QuickView from '../components/quick-view';
import Search from '../components/search-bar';
import Tables from '../templates/policy';
import Video from '../components/video';

/**
 * Global Karmoon utils
 */
window.Karmoon = window.Karmoon || {};
window.Karmoon.EventBus = EventBus();

document.addEventListener('DOMContentLoaded', () => {
  AjaxCart().init();
  CartFunctions().init();
  FreeGift().init();
  FreeShipping().init();
  GiftWrap().init();
  Loadpage().init();
  Location().init();
  ModalLocation().init();
  MeganavProduct().init();
  Navigation().init();
  Search().init();
  Video().init();
  LazyVideo().init();

  if (theme.collection.quickView) {
    QuickView().init();
  }

  if (theme.collection.quickAdd) {
    QuickAdd().init();
  }

  if (document.querySelector('.accordion') !== null) {
    Accordion('.accordion', {
      singleOpen: true,
    }).init();
    Accordion('.accordion').showInitialItem();
  }

  if (document.getElementsByTagName('table') !== null) {
    Tables();
  }

  load('*');

  if (Shopify.theme.role == 'unpublished') {
    console.log(Shopify.theme);
  }
});

// Common a11y fixes
focusHash();
